/* eslint-disable sonarjs/cognitive-complexity */
import skpDetailTableContent from 'features/Enterprise/SKP/constant'
import { TableHeadsType } from 'features/Enterprise/SKP/components/SKPTable/useSKPTable'
import { PageType, SectionType } from 'features/Enterprise/SKP/components/SKPDetails/useSKPDetails'

const tableContent = ({
  content = [''],
  isActionActive = false,
  showExpandOnly = false,
}: {
  content: string[]
  isActionActive?: boolean
  showExpandOnly?: boolean
}) => [
  ...skpDetailTableContent.filter((x) => content.includes(x.keyValue)),
  {
    name: 'ACTION',
    keyValue: 'action',
    type: showExpandOnly ? 'expand_action' : 'add_edit_action',
    isActive: isActionActive,
  },
]

export const generateTableContent = ({
  content,
  skpStatus,
  pageType,
  sectionType,
  isBmsm,
  isAllowedToEdit = true,
}: {
  content: string[]
  skpStatus: string
  pageType: PageType
  sectionType: SectionType
  isBmsm?: boolean
  isAllowedToEdit?: boolean
}): TableHeadsType[] => {
  const isDraftRejected = skpStatus === 'Draft' || skpStatus === 'Rejected'

  if (sectionType === 'promotions') {
    let isActionActive = false
    let showExpandOnly = true

    if (
      isAllowedToEdit &&
      (pageType === 'sourcing' || pageType === 'internal') &&
      isDraftRejected
    ) {
      showExpandOnly = false
      isActionActive = true
    }

    return tableContent({
      content,
      isActionActive: isBmsm ? true : isActionActive,
      showExpandOnly: isBmsm ? showExpandOnly : false,
    })
  }

  if (pageType === 'sourcing' && sectionType === 'agreements') {
    return tableContent({ content, isActionActive: isDraftRejected })
  }

  if (sectionType === 'actualClaims') {
    return tableContent({
      content,
      isActionActive: true,
      showExpandOnly: isBmsm,
    })
  }

  if (
    (pageType === 'campaign' && sectionType === 'proofDocuments') ||
    (pageType === 'finance' && sectionType === 'reimbursements')
  ) {
    return tableContent({ content, isActionActive: true })
  }

  return tableContent({ content })
}
